export class RoundNameConstants {
    public static PRACTICE_BIDDING_ROUND = '1';
    public static PRACTICE_CONFIRMATION_ROUND = '2';
    public static BIDDING_ROUND_ONE = '3';
    public static CONFIRMATION_ROUND1 = '4';
    public static BIDDING_ROUND_TWO = '5';
    public static CONFIRMATION_ROUND2 = '6';
    public static BIDDING_ROUND_THREE = '7';
    public static CONFIRMATION_ROUND3 = '8';
    public static BIDDING_ROUND_FOUR = '9';
    public static CONFIRMATION_ROUND4 = '10';
}
